import { config } from "../config";
import { devHeroSlug } from "../lib/landing";
import { createHttpApi } from "./client";
import type { HeroApi } from "./types";

export type { HeroApi } from "./types";
export { ApiError, describeError, isApiError } from "./errors";

/**
 * Какой API у этой сборки. Мок подключается динамическим импортом: в обычной сборке
 * условие известно заранее, и ни мок, ни его картинки в бандл не попадают.
 */
export async function createApi(): Promise<HeroApi> {
  // Заголовок x-hero — только там, где нет поддомена: dev-сервер и мок-демо
  const heroSlug = config.dev || config.mock ? devHeroSlug(config.devHero) : null;
  if (config.mock) {
    const { createMockApi } = await import("./mock");
    const api = createMockApi({ heroSlug });
    // Ручка для отладки и проверок в браузере: события аналитики, состояние, сброс
    (window as unknown as { __scrileMock?: unknown }).__scrileMock = api.debug;
    return api;
  }
  return createHttpApi({ heroSlug, strict: config.dev });
}
